import { CheckCircle2, XCircle, Info, AlertTriangle, X } from 'lucide-react';
import { useToastStore, type ToastType } from '@/stores/toast-store';

const iconMap: Record<ToastType, typeof CheckCircle2> = {
  success: CheckCircle2,
  error: XCircle,
  info: Info,
  warning: AlertTriangle,
};

const borderColorMap: Record<ToastType, string> = {
  success: 'border-l-accent-green',
  error: 'border-l-accent-red',
  info: 'border-l-accent-blue',
  warning: 'border-l-accent-yellow',
};

const iconColorMap: Record<ToastType, string> = {
  success: 'text-accent-green',
  error: 'text-accent-red',
  info: 'text-accent-blue',
  warning: 'text-accent-yellow',
};

export function ToastContainer() {
  const toasts = useToastStore((s) => s.toasts);
  const removeToast = useToastStore((s) => s.removeToast);

  if (toasts.length === 0) return null;

  return (
    <div className="fixed bottom-4 right-4 z-50 flex flex-col gap-2">
      {toasts.map((toast) => {
        const Icon = iconMap[toast.type];
        return (
          <div
            key={toast.id}
            className={`
              min-w-[280px] max-w-[400px] bg-dbgo-panel border border-l-4
              ${borderColorMap[toast.type]}
              rounded-lg px-4 py-3 shadow-lg
              animate-toast-in
              flex items-start gap-3
            `}
          >
            <Icon size={16} className={`flex-shrink-0 mt-0.5 ${iconColorMap[toast.type]}`} />
            <span className="text-xs text-text-primary flex-1 leading-relaxed">{toast.message}</span>
            <button
              onClick={() => removeToast(toast.id)}
              className="flex-shrink-0 text-text-muted hover:text-text-secondary transition-colors"
            >
              <X size={14} />
            </button>
          </div>
        );
      })}
    </div>
  );
}
